<template>
    <v-chip
        :color = "validEmails ? color : 'error'"
        style  = "width: 240px;"
        @click:close = "onRemove"
        close
    >
        <div>
            <p-recipient-chip-menu
                v-if="recipient.emails.length > 1"
                :email-list = "recipient.emails"
            />
        </div>
        <div class="pl-1" :style="'width:' + width">
            <div>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind="attrs"
                            v-on="on"
                            class="recipient-chip"
                        >
                            {{ recipient.name }} {{ recipient.company ? recipient.company.name : '' }}
                        </div>
                    </template>

                    <div >
                        {{ recipient.name }} {{ recipient.company ? recipient.company.name : '' }}
                    </div>
                </v-tooltip>


            </div>
            <div class="recipient-mail">
                {{ recipient.email }}
            </div>
        </div>
    </v-chip>
</template>

<script>
import PRecipientChipMenu from "@/modules/inc/mail/private/PRecipientChipMenu.vue";
export default {
    name: "PRecipientChip",

    components: {
        PRecipientChipMenu
    },

    props: {
        recipient: {
            default: function () {
                return {
                    emails: [],
                }
            }
        },

        color: {

        }
    },

    computed: {
        validEmails () {
            if (!this.recipient.emails) {
                return false;
            }

            let valid = true;
            this.recipient.emails.forEach(email => {
                if (!email.valid) {
                   valid = false;
                }
            });

            return valid;
        },

        width () {
            if (this.recipient.emails.length > 1) {
                return "180px";
            }

            return "198px";
        }
    },

    methods: {
        onRemove () {
            this.$emit("remove", this.recipient)
        },
    }
}
</script>

<style scoped>


.recipient-chip {
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.recipient-mail {
    font-size: 9px;
    margin-top: -7px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.recipient-mail-input {
    margin-top: -2px;
    padding-left: 5px;
}

</style>